// extracted by mini-css-extract-plugin
module.exports = {"content":"e2ff468f85--content--DSYY_","text":"e2ff468f85--text--q9pjX","counter":"e2ff468f85--counter--_eTet","arrow":"e2ff468f85--arrow--uoCQe"};